var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmile = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 32c8.837 0 16-7.163 16-16s-7.163-16-16-16S.5 7.163.5 16s7.163 16 16 16Zm-5.833-17.949c0 1.133-.933 2.052-2.084 2.052-1.15 0-2.083-.919-2.083-2.052S7.433 12 8.583 12c1.15 0 2.084.918 2.084 2.051Zm15.833 0c0 1.133-.933 2.052-2.083 2.052-1.15 0-2.084-.919-2.084-2.052S23.266 12 24.417 12c1.15 0 2.083.918 2.083 2.051Zm-10.002 8.616a8.368 8.368 0 0 0 6.333-2.872H10.165a8.368 8.368 0 0 0 6.333 2.872Z",
    fill: "#FB8E63"
  })));
};
export { SvgSmile as ReactComponent };